import CountdownBar from "@/components/CountdownBar";
import NavBar from "@/components/NavBar";
import Hero from "@/components/sections/Hero";
import ValueStack from "@/components/sections/ValueStack";
import Portfolio from "@/components/sections/Portfolio";
import Testimonials from "@/components/sections/Testimonials";
import About from "@/components/sections/About";
import Pricing from "@/components/sections/Pricing";
import ApplicationForm from "@/components/sections/ApplicationForm";
import FAQ from "@/components/sections/FAQ";
import Footer from "@/components/sections/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-[#F6F1E8] text-foreground min-h-screen">
      <CountdownBar />
      <NavBar />
      <Hero />
      <ValueStack />
      <Testimonials />
      <Portfolio />
      <About />
      <Pricing />
      <ApplicationForm />
      <FAQ />
      <Footer />
      <StickyMobileCTA />
    </main>
  );
}
